
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 512 512","fill":"currentColor","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st0",attrs:{"d":"M84.6 295.5l44.4 26.8-13.9 58.8c-3.1 13.3 5.1 26.7 18.4 29.8 1.9.4 3.8.7 5.7.7.4 0 .7-.2 1-.2L98.9 496c-1.8 4-.2 8.7 3.7 10.7 4 2.1 9 .6 11.2-3.5L196 334.9l.5 1.7c1.9 5.9 6 10.9 11.4 14l-18.3 50.6c-.7 1.9-1.5 3.7-2.6 5.5l-47 79.5c-1.2 2-1.8 4.3-1.8 6.7 0 7.2 5.9 13.1 13.1 13H425c7.2 0 13.1-5.9 13.1-13.1V23.5c0-7.2-5.9-13.1-13.1-13.1h-57.5c-5.9 0-11 3.9-12.6 9.6l-27.7 100.5-31.2 57.6c-1.7 3.1-2.9 6.5-3.4 10l-16 93c-1.5 8.7-6.4 16.4-13.7 21.3l-20.8 14.2-14.6-46.5 60.4-123.8 9.5-9.1c4.9-4.7 6.4-11.9 3.8-18.1l46.6-95.4c1.8-4 .2-8.7-3.7-10.7-4-2.1-9-.6-11.2 3.5l-45.2 92.7c-4.8-.6-9.6 1-13.2 4.3L229 157.2l-43.9-7.8-27.6-10.4c-17-6.4-36 2.2-42.4 19.3 0 0-29.1 77.6-38.8 103.4-5.8 15.8-.4 28.6 8.3 33.8zm135.7-48.2l-.3-.9c-3.8-12.1-16.2-19.4-28.6-16.8l-35.2 7.3 20.8-55.5 54.5 9.8c1 .2 1.9.3 2.9.3 4.3 0 8.4-1.7 11.5-4.6l7.5-7.3-33.1 67.7zm-43.9 90l5-21.1c2.5-10.5-2.1-21.3-11.3-26.9l-5.7-3.5 15.1-3.1 9.2 29.3-12.3 25.3z"}}),_c('path',{staticClass:"st0",attrs:{"d":"M177.9 134c20.5 0 37.1-16.6 37-37.1 0-20.5-16.6-37-37-37-20.5 0-37.1 16.6-37.1 37s16.6 37.1 37.1 37.1z"}})])
          )
        }
      }
    